import { RouteObject } from "react-router-dom";
import { TopBarPageContainer } from "../../components/PageContainer";
import ReportsPage from "./ReportsPage";

export const REPORTS_ROUTES: RouteObject[] = [
  {
    index: true,
    element: (
      <TopBarPageContainer title="Automated reports">
        <ReportsPage />
      </TopBarPageContainer>
    ),
  },
];
